
// export default RadioButtunTable
import React, { useEffect, useState } from 'react';
import './RadioButtunTable.css';
import iconPlus from '../../Images/IconPlus.svg';
import iconMinus from '../../Images/IconMinus.svg';
//tow implimentaion one radio and one billing and trasition changes

function RadioButtunTable(props) {

  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ column: null, direction: 'asc' });
  let showToggle
  useEffect(() => {

    if (showToggle) {
      setOpen(showToggle || false)
    }
  }, [showToggle])

  

  if (!props?.item?.text) {
    return null; // nothing will render
  }

  const data = (() => {
  if (!props?.item?.text) return {};

  try {
    return JSON.parse(props.item.text);
  } catch (e) {
    return  props.item.text ;
  }
})();


  showToggle = data?.isR3OneView;





  if (data?.tableRows?.length === 0) {
    return
  }
  let heading = props?.item?.data ? JSON.parse(props?.item?.data) : {}


  const { tableHeading, tableRows, isRadioButton } = data;

  const handleSort = (colIndex) => {
    const direction = sortConfig.column === colIndex && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ column: colIndex, direction });
  };

  const getSortedRows = (rows) => {
    if (sortConfig.column === null) return rows;

    return [...rows].sort((a, b) => {
      const aVal = a[sortConfig.column];
      const bVal = b[sortConfig.column];

      const aText = aVal?.replace(/<[^>]*>/g, '') || '';
      const bText = bVal?.replace(/<[^>]*>/g, '') || '';

      const aNum = parseFloat(aText);
      const bNum = parseFloat(bText);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
      }

      return sortConfig.direction === 'asc'
        ? aText.localeCompare(bText)
        : bText.localeCompare(aText);
    });
  };

  const sortedRows = getSortedRows(tableRows);




  const handleRowSelect = (rowIndex) => {
    setSelectedRowIndex(rowIndex);
    // if (!data?.isRadioButton) {
    //  return
    // }
    props?.setErrors?.((prevErrors) => {
      const RowIdArray = tableRows[rowIndex];
      const updatedErrors = {
        ...prevErrors,
        [props?.index]: {
          key1: RowIdArray[0],
          displayName: RowIdArray[0],
        },
      };
      console.log("Updated Errors after user selection:", updatedErrors);
    
      return updatedErrors;
    });
  };

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        padding: '0px 12px',
        border: showToggle && "1px solid #b8b8b8",
        borderRadius: showToggle && "12px",
        margin: showToggle && "20px 0px",
        background: showToggle && "rgb(248 220 255 / 96%)",
        boxShadow: showToggle
          ? "inset 0 2px 6px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.08)"
          : "none",
        transition: showToggle && "box-shadow 0.3s ease"
      }}
    >

      {showToggle && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            margin: '10px 0px',
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '12px 12px 12px 0px;',
          }}
          onClick={() => setOpen(!open)}
        >
          {/* <div className='A3f'>{heading?.heading}</div> */}
          <h3
        style={{ fontSize: !props?.showMaximumChat && "13px" }}
        className="a3billing-heading"
      >
        {heading?.heading}
      </h3>
          <img
            src={open ? iconMinus : iconPlus}
            alt="toggle"
            style={{ width: '20px', height: '20px' }}
          />
        </div>
      )}
      {open && (
        <div className="responsive-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                {isRadioButton && <th className="radio-column A3f"></th>}
                {tableHeading?.map((heading, index) => (
                  <th 
                    key={index} 
                    onClick={() => handleSort(index)} 
                    className={sortConfig.column === index ? 'sorted-column' : ''}
                    style={{ cursor: 'pointer' }}
                  >
                    {heading}
                    <span style={{ marginLeft: '5px' }}>
                      {sortConfig.column === index
                        ? (sortConfig.direction === 'asc' ? '↑' : '↓')
                        : '↕'}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {sortedRows.map((row, rowIndex) => {
                const isSelected = selectedRowIndex === rowIndex;
                return (
                  <tr
                    key={rowIndex}
                    className={`table-row `}
                    // onClick={() => handleRowSelect(rowIndex)}
                  >
                    {isRadioButton && (
                      <td className="radio-column">
                        <input
                          type="radio"
                          name="row-select"
                          checked={isSelected}
                          onChange={() => handleRowSelect(rowIndex)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </td>
                    )}
                    {tableHeading?.map((_, colIndex) => (
                      <td
                        key={colIndex}
                        dangerouslySetInnerHTML={{
                          __html: row[colIndex] ? row[colIndex] : "-",
                        }}
                      ></td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>

        </div>)}
        {!open && !showToggle && (
        <div className="responsive-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                {isRadioButton && <th className="radio-column A3f"></th>}
                {tableHeading?.map((heading, index) => (
                  <th 
                    key={index} 
                    onClick={() => handleSort(index)} 
                    className={sortConfig.column === index ? 'sorted-column' : ''}
                    style={{ cursor: 'pointer' }}
                  >
                    {heading}
                    <span style={{ marginLeft: '5px' }}>
                      {sortConfig.column === index
                        ? (sortConfig.direction === 'asc' ? '↑' : '↓')
                        : '↕'}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {sortedRows.map((row, rowIndex) => {
                const isSelected = selectedRowIndex === rowIndex;
                return (
                  <tr
                    key={rowIndex}
                    className={`table-row ${isSelected ? "selected-row" : ""}`}
                    onClick={() => handleRowSelect(rowIndex)}
                  >
                    {isRadioButton && (
                      <td className="radio-column">
                        <input
                          type="radio"
                          name="row-select"
                          checked={isSelected}
                          onChange={() => handleRowSelect(rowIndex)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </td>
                    )}
                    {tableHeading?.map((_, colIndex) => (
                      <td
                        key={colIndex}
                        dangerouslySetInnerHTML={{
                          __html: row[colIndex] ? row[colIndex] : "-",
                        }}
                      ></td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>

        </div>)}
    </div>
  );
}

export default RadioButtunTable;
